import Link from 'ui/Link';

type Props = {
  href: string;
  label: string;
};

const FooterLink: React.FC<Props> = ({ href, label }) => (
  <Link variant="neutral" color="gray.500" fontSize="xs" href={href} isExternal>
    {label}
  </Link>
);

export default FooterLink;
